import React, { useState } from 'react'
import { Card, Col, Flex, Form, Row, Typography, Button } from 'antd'
import { AppointmentCalender, Appointmenttable, ModuleTopHeading, SearchInput } from '../../components';

const { Text } = Typography
const Appointment = () => {
    const [ current, setCurrent ] = useState(true)
    const [visible, setVisible] = useState(false)
    const [edititem, setEditItem] = useState(null)
    const [form] = Form.useForm();

    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex justify='space-between' align='center' gap={10} wrap>
                            <ModuleTopHeading level={4} name='Appointment' />
                            <Flex gap={'small'}>
                                <Button
                                    onClick={() => setCurrent(!current)}
                                    className='bg-transparent border0 p-0'
                                >
                                    {
                                        current ?
                                        <img src="/assets/icons/list.png" alt="" width={25} />
                                        :
                                        <img src="/assets/icons/grid.png" alt="" width={25} />
                                    }
                                </Button>
                            </Flex>
                        </Flex>
                    </Col>
                    <Col span={24}>
                    {
                        current ?
                        <Appointmenttable {...{ setEditItem, setVisible }} />
                        :
                        <AppointmentCalender/>
                    }
                        
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { Appointment }
